import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "bootstrap";
import { useLanguage } from "../context/LanguageContext";
import GoogleLoginButton from "../components/GoogleLoginButton";
import "../styles/style.css";
import { useBodyScrollLock } from "../hooks/useBodyScrollLock";
import { LEGAL_PATHS } from "../legal/legalContent";

interface Props {
  onClose: () => void;
  loggedIn: boolean;
  onLoginSuccess: () => void;
  onLogout: () => void;
}

function MobileAccountPopup({ onClose, loggedIn, onLoginSuccess, onLogout }: Props) {
  useBodyScrollLock();
  const navigate = useNavigate();
  const { t, lang, setLang } = useLanguage();
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    setTimeout(onClose, 300);
  };

  const goTo = (path: string) => {
    handleClose();
    setTimeout(() => navigate(path), 300);
  };

  const openModal = (modalId: string) => {
    handleClose();
    setTimeout(() => {
      const el = document.getElementById(modalId);
      if (el) {
        Modal.getOrCreateInstance(el).show();
      }
    }, 400);
  };

  return (
    <div
      className={`mobile-bottom-popup-overlay${closing ? " mobile-bottom-popup-overlay--closing" : ""}`}
      onClick={(e) => { if (e.target === e.currentTarget) handleClose(); }}
    >
      <div className={`mobile-bottom-popup ${closing ? "mobile-bottom-popup--closing" : "mobile-bottom-popup--animate"}`}>
        <div className="d-flex justify-content-between align-items-center px-3 pt-3 pb-1">
          <h6 className="fw-bold mb-0">
            <i className="bi bi-person-circle me-2" style={{ color: "#c20e1a" }}></i>
            {t("account.title")}
          </h6>
          <button className="btn-close" onClick={handleClose} aria-label={t("common.close")} />
        </div>

        <div className="mt-2">
          {loggedIn ? (
            <>
              <button className="mobile-account-popup__item" onClick={() => goTo("/profil")}>
                <i className="bi bi-person"></i>
                <span>{t("account.myProfile")}</span>
              </button>
              <button className="mobile-account-popup__item" onClick={() => goTo("/adreslerim")}>
                <i className="bi bi-geo-alt"></i>
                <span>{t("account.myAddresses")}</span>
              </button>
              <button className="mobile-account-popup__item" onClick={() => goTo("/orderhistory")}>
                <i className="bi bi-receipt"></i>
                <span>{t("account.myOrders")}</span>
              </button>
              <div className="px-3 py-3 border-bottom">
                <small className="text-muted fw-semibold d-block mb-2">{t("account.language")}</small>
                <div className="btn-group w-100">
                  <button
                    className={`btn btn-sm ${lang === "tr" ? "btn-danger" : "btn-outline-secondary"}`}
                    onClick={() => setLang("tr")}
                  >
                    TR
                  </button>
                  <button
                    className={`btn btn-sm ${lang === "en" ? "btn-danger" : "btn-outline-secondary"}`}
                    onClick={() => setLang("en")}
                  >
                    EN
                  </button>
                </div>
              </div>

              <button className="mobile-account-popup__item" onClick={() => { handleClose(); setTimeout(onLogout, 300); }}>
                <i className="bi bi-box-arrow-left"></i>
                <span>{t("account.logout")}</span>
              </button>
              <button className="mobile-account-popup__item mobile-account-popup__item--danger" onClick={() => openModal("deleteAccountModal")}>
                <i className="bi bi-trash3"></i>
                <span>{t("account.deleteAccount")}</span>
              </button>
            </>
          ) : (
            <>
              <button className="mobile-account-popup__item" onClick={() => openModal("loginModal")}>
                <i className="bi bi-box-arrow-in-right"></i>
                <span>{t("account.login")}</span>
              </button>
              <button className="mobile-account-popup__item" onClick={() => openModal("registerModal")}>
                <i className="bi bi-person-plus"></i>
                <span>{t("account.register")}</span>
              </button>

              <div className="px-3 py-3 border-bottom">
                <small className="text-muted fw-semibold d-block mb-2">{t("account.languagePreference")}</small>
                <div className="btn-group w-100">
                  <button
                    className={`btn btn-sm ${lang === "tr" ? "btn-danger" : "btn-outline-secondary"}`}
                    onClick={() => setLang("tr")}
                  >
                    TR
                  </button>
                  <button
                    className={`btn btn-sm ${lang === "en" ? "btn-danger" : "btn-outline-secondary"}`}
                    onClick={() => setLang("en")}
                  >
                    EN
                  </button>
                </div>
              </div>

              <div className="px-3 py-3">
                <GoogleLoginButton onLoginSuccess={() => { onClose(); onLoginSuccess(); }} />
              </div>
            </>
          )}

          <div className="px-3 pt-3 pb-1">
            <small className="text-muted fw-semibold">{t("legal.section")}</small>
          </div>
          <button className="mobile-account-popup__item" onClick={() => goTo(LEGAL_PATHS.privacy)}>
            <i className="bi bi-shield-lock"></i>
            <span>{t("legal.privacy")}</span>
          </button>
          <button className="mobile-account-popup__item" onClick={() => goTo(LEGAL_PATHS.terms)}>
            <i className="bi bi-file-earmark-text"></i>
            <span>{t("legal.terms")}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default MobileAccountPopup;
